var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReportTitleEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.034,
    height: 13.034,
    viewBox: "0 0 13.034 13.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75464",
    "data-name": "Group 75464",
    transform: "translate(-1047.998 -312.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51412",
    "data-name": "Group 51412",
    transform: "translate(1047.998 313.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51411",
    "data-name": "Group 51411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71169",
    "data-name": "Path 71169",
    d: "M11.309,53.451a.526.526,0,0,0-.527.526v3.2a.672.672,0,0,1-.672.672H1.725a.672.672,0,0,1-.672-.672V48.79a.672.672,0,0,1,.672-.672h3.2a.526.526,0,1,0,0-1.053h-3.2A1.727,1.727,0,0,0,0,48.79v8.387A1.727,1.727,0,0,0,1.725,58.9h8.387a1.727,1.727,0,0,0,1.725-1.725v-3.2A.526.526,0,0,0,11.309,53.451Z",
    transform: "translate(0 -47.065)",
    fill: "#f45e29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51414",
    "data-name": "Group 51414",
    transform: "translate(1051.593 312.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51413",
    "data-name": "Group 51413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71170",
    "data-name": "Path 71170",
    d: "M150.477,2.551l-2.4-2.4a.526.526,0,0,0-.745,0l-5.99,5.99a.527.527,0,0,0-.154.372v2.4a.526.526,0,0,0,.526.526h2.4a.526.526,0,0,0,.372-.154l5.991-5.99a.526.526,0,0,0,0-.745ZM143.9,8.387h-1.652V6.735l5.464-5.464,1.652,1.652Z",
    transform: "translate(-141.191 0)",
    fill: "#f45e29"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportTitleEdit);
export default __webpack_public_path__ + "static/media/icon-report-title-edit.0b0b3ec8.svg";
export { ForwardRef as ReactComponent };